import fetch from '../utils/fetch';
import makeService from './api';

const ENDPOINT = 'credit_transfers';

export default {
  ...makeService(ENDPOINT),
  findInCreditTransferPaymentRun(id) {
    return fetch(`${id}/credit_transfers`);
  }
}
